import { render } from "./Share.vue?vue&type=template&id=16dce2c9&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=16dce2c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\17630037586\\Desktop\\新建文件夹 (2)\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dce2c9"]])

export default __exports__